<template>
<div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.goodbye')}}
      </h3>
    </div>
    <div class="custom-container">
      <div class="content text-center">
        <div class="d-flex justify-content-center">
          <span class="header header-4">{{$t('headers.goodbye_message')}}</span>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <span class="header header-4">{{primaryResultText}}</span>
        </div>

        <div class="d-flex justify-content-center mt-2">
          <span class="header header-4">{{secondaryResultText}}</span>
        </div>
      </div>
    </div>
</div>
</template>
<script>
export default {
  props: {
    hasHearingLoss: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    primaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.hearing_loss.has_loss') : this.$t('results_stage.hearing_loss.ok')
    },
    secondaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.recommendations.schedule') : this.$t('results_stage.recommendations.yearly_test')
    },
  },
  mounted () {
    // this.$ga.event({
    //   eventCategory: 'questionnaire',
    //   eventAction: 'contact-form',
    //   eventLabel: 'Submetido',
    //   eventValue: 1
    // })
  }
}
</script>